import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=ae4c778e&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=ts"
export * from "./Voting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4c778e",
  null
  
)

export default component.exports